import $ from 'jquery';
import Swiper from 'swiper';
import Navigation from 'swiper/modules/navigation.mjs';
import Pagination from 'swiper/modules/pagination.min.mjs';
import Autoplay from 'swiper/modules/autoplay.min.mjs';
import EffectFade from 'swiper/modules/effect-fade.mjs';

 
const slider = new Swiper('.hero__swiper', {
    modules: [Autoplay,Navigation],
    speed: 1200,
    spaceBetween: 15,
    loop: false,
    slidesPerView: 1,
    autoplay: {
        delay: 8000,
        disableOnInteraction: true, 
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
  });
 
const opinie__swiper = new Swiper('.opinie__swiper', {
    modules: [Autoplay],
    speed: 1200,
    spaceBetween: 15,
    loop: false,
    slidesPerView: 1,
    autoplay: {
        delay: 8000,
        disableOnInteraction: true, 
    },
  });
const tesl__slider = new Swiper('.tesl__slider', {
    modules: [Autoplay,Pagination],
    speed: 1200,
    spaceBetween: 15,
    loop: true,
    slidesPerView: 1,
    autoplay: {
        delay: 8000,
        disableOnInteraction: true, 
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true, 
    },
  });

  
const blogtop__slider = new Swiper('.blogtop__slider', {
    modules: [Autoplay, Navigation, Pagination],
    speed: 1000,
    spaceBetween: 10,
    loop: true,
    slidesPerView: 1,
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
    },
    navigation: { 
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
  // const review__box = new Swiper('.review__box', {
  //   modules: [Autoplay,Pagination],
  //   speed: 800,
  //   spaceBetween: 15,
  //   loop: false,
  //   slidesPerView: 1,
  //   autoplay: {
  //       delay: 8000,
  //       disableOnInteraction: true,
  //   },
  //   pagination: {
  //     el: '.swiper-pagination__review',
  //     clickable: true, 
  //   },
  // });
  
const postyslider__slider = new Swiper(".postyslider__slider", {
    modules: [Autoplay,Navigation],
    loop: false,
    speed: 600,
    slidesPerView:1,
    spaceBetween: 10,
    autoplay: {
        delay: 5050,
        disableOnInteraction: false,
    },
    // Navigation arrows
    navigation: {
      nextEl: '.postyslider__arrow--next',
      prevEl: '.postyslider__arrow--prev'
    },
    breakpoints: {
        '1100': {
          slidesPerView: 2,
        },
      }
});




